import errorImages from "common/constants/errorImages";

import Page from "client/common/components/layouts/Page";
import Body from "client/common/components/layouts/Body";
import Subheader from "client/common/components/layouts/Subheader";
import Results from "client/common/components/results/Results";
import { urls } from "client/routes";

import Prescription from "./Prescription";
import { usePrescriptionsQuery } from "../hooks";

import styles from "../styles/PrescriptionsPage.module.less";

const Prescriptions = () => {
  const { data: prescriptions, isLoading, error: prescriptionsError } = usePrescriptionsQuery();

  if (isLoading) {
    return <Results.Loading description="Loading prescriptions" />;
  }

  if (!prescriptions || prescriptionsError) {
    return (
      <Results.FetchError entityName="prescriptions" error={prescriptionsError} isPlural={true} />
    );
  }

  if (!prescriptions.length) {
    return (
      <Results.None
        image={errorImages.EmptyPrescriptions}
        header="You don't have any prescriptions."
        dest={urls.products.search()}
        button="Search Products"
      />
    );
  }

  return (
    <div className={styles.prescriptions}>
      {prescriptions.map((prescription) => (
        <Prescription key={prescription.id} prescription={prescription} />
      ))}
    </div>
  );
};

const PrescriptionsPage = () => {
  return (
    <Page>
      <Subheader
        classNames={{ actions: styles.actions }}
        title="My Pet's Prescriptions"
        description="Easily fill my pet's medications"
      />
      <Body>
        <Prescriptions />
      </Body>
    </Page>
  );
};

export default PrescriptionsPage;
